/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit';
import { ariActions, threadActions } from '../actions';
import { hrsDay, millisecondsHr, messageTypes, channelTypes } from 'appConstants';

const initialState = {
	user: {
		page: 1,
		isLoading: true,
		threads: [],
		unreadThreads: {},
		totalUnreadMessageCount: 0
	},
	team: {
		page: 1,
		isLoading: true,
		threads: [],
		unreadThreads: {},
		totalUnreadMessageCount: 0
	},
	threadMessages: {
		isLoading: false,
		errorMessage: null,
		markedRead: false,
		// this is needed to whatsaaaaaaaaaap!
		wasActiveInLast24Hrs: true,
		messages: [],
		relatedThread: {},
		ariState: {
			thread: {
				sequenceEnabled: false
			},
			isEnabling: false,
			isDisabling: false,
			isLoading: false,
			sequences: []
		}
	}
};

const getTargetThreadIndexes = (state, threadId) => {
	const r = { user: -1, team: -1 };
	['team', 'user'].forEach((inboxType) => {
		for (let i = 0; i < state[inboxType].threads.length; i++) {
			if (state[inboxType].threads[i].id === threadId) {
				r[inboxType] = i;
				return;
			}
		}
	});
	return r;
};

const didCandidateWhatsAppInLast24hrs = (messages) => {
	let candidateRespondedInLast24Hrs = false;
	const now = new Date();
	for (const message of messages) {
		if (
			message.channel === channelTypes.WHATS_APP &&
			message.type === messageTypes.INBOUND &&
			(now - new Date(message.time)) / millisecondsHr < hrsDay
		) {
			candidateRespondedInLast24Hrs = true;
			break;
		}
	}
	return candidateRespondedInLast24Hrs;
};

const addNewThread = (state, thread) => {
	const userThreads = state.user.threads;
	if (userThreads[0]) {
		if (thread.userName === userThreads[0].userName) {
			state.user.threads.unshift(thread);
		} else {
			// Find thread
			for (let i = 0; i < userThreads.length; i++) {
				if (userThreads[i].candidateId === thread.candidateId) {
					const l = userThreads.slice(0, i);
					const r = userThreads.slice(i + 1);
					state.user.threads = l.concat(thread).concat(r);
				}
			}
		}
	}
};

const updateInboxThreads = (state, inboxType, page, threads) => {
	if (threads.length) {
		let res = [];
		// eslint-disable-next-line no-undefined
		if (state[inboxType][page] === undefined) {
			state[inboxType][page] = [];
		}
		state[inboxType][page] = threads;
		for (let p = 1; p < page + 1; p++) {
			res = res.concat(state[inboxType][p]);
		}
		return res;
	}
	return state[inboxType].threads;
};

const setMessages = (state, action) => {
	const { message, thread } = action.payload;
	const { messages } = state.threadMessages;
	const exists = Boolean(messages.filter((msg) => msg.id === message.id).length);
	if (exists) {
		return;
	}

	// TODO: There is a backend websocket issue where the sequenceEnabled boolean is NOT
	// coming in as enabled, even though it is emitted. Once that is fixed, the lines below
	// should update ARI state in real time when it's enabled across applications.
	// state.threadMessages.ariState.thread.sequenceEnabled = Boolean(
	// 	thread && thread.threadMessages.ariState.thread.sequenceEnabled
	// );

	if (message.type === messageTypes.INBOUND && message.candidateName === undefined) {
		message.candidateName = '';
	}

	if (message.type === messageTypes.OUTBOUND && message.userFirstName === undefined) {
		message.userFirstName = '';
	}

	if (
		message.type === messageTypes.OUTBOUND &&
		message.sentVia === undefined &&
		message.messageText
	) {
		// TODO: This is a temp. solution to unblock the broken UI. Should resolve with more exacting data -Amir
		// See DGA-241
		message.sentVia = 'Human';
	}

	/**
	 * Check if candidate responded w/ a WhatsApp message,
	 * And update the wasActiveInLast24Hrs flag
	 */
	const didWhatsAppInLast24Hrs =
		message.channel === channelTypes.WHATS_APP &&
		message.type === messageTypes.INBOUND &&
		(new Date() - new Date(message.time)) / millisecondsHr < hrsDay;

	if (didWhatsAppInLast24Hrs) {
		state.threadMessages.wasActiveInLast24Hrs = true;
	}

	// Find if msg belongs to any existing loaded threads
	const indexes = getTargetThreadIndexes(state, thread.id);

	// Add new msg
	if (message.messageText) {
		message.messageText = message.messageText.replace(/(\<|\>)/g, '');
	}
	messages.push(message);

	let inboxes = [];

	function updateThreads() {
		inboxes.forEach((inbox) => {
			const leftThreads = state[inbox].threads.slice(0, indexes[inbox]);
			const rightThreads = state[inbox].threads.slice(indexes[inbox] + 1);
			state[inbox].threads = leftThreads.concat(thread).concat(rightThreads);
			if (message.type === 0) {
				state[inbox].totalUnreadMessageCount += 1;
			} else {
				state[inbox].totalUnreadMessageCount -=
					state[inbox].threads[indexes[inbox]].unreadMessageCount;
			}
		});
	}

	// Found in both user & team inboxes
	if (indexes.user !== -1 && indexes.team !== -1) {
		inboxes = ['user', 'team'];
		updateThreads();
	}
	// Found in team inbox only
	else if (indexes.team !== -1) {
		inboxes = ['team'];
		updateThreads();
	}
	// Found in user inbox only
	else if (indexes.user !== -1) {
		inboxes = ['user'];
		updateThreads();
	}
	// New Thread
	// TODO: this isn't necessarily correct. Candidate could be searched and msged to.
	addNewThread(state, thread);
};

const formatMessages = (messages) => {
	return messages.map((msg) => {
		if (msg.type === messageTypes.INBOUND && msg.candidateName === undefined) {
			msg.candidateName = '';
		}
		if (msg.type === messageTypes.OUTBOUND && msg.userFirstName === undefined) {
			msg.userFirstName = '';
		}
		if (msg.type === messageTypes.OUTBOUND && msg.sentVia === undefined && msg.messageText) {
			// TODO: This is a temp. solution to unblock the broken UI. Should resolve with more exacting data -Amir
			// See DGA-241
			msg.sentVia = 'Human';
		}

		// TODO: This is a temp. workaround for html-react-parser lib, that's detecting <> as JSX element :-/
		if (msg.messageText) {
			msg.messageText = msg.messageText.replace(/(\<|\>)/g, '');
		}
		return msg;
	});
};

const threadSlice = createSlice({
	name: 'thread',
	initialState,
	reducers: {},
	extraReducers: {
		// Dynamically handles all inbox types via inboxType provided by redux-thunk
		[threadActions.getThreads.fulfilled]: (state, action) => {
			const inboxType = action.meta.arg.inboxType.toLowerCase();
			state[inboxType].isLoading = false;
			state[inboxType].threads = updateInboxThreads(
				state,
				inboxType,
				action.payload.paging.page,
				action.payload.threads
			);
			state[inboxType].page = action.payload.paging.page;
		},
		[threadActions.getThreads.rejected]: (state, action) => {
			const inboxType = action.meta.arg.inboxType.toLowerCase();
			state[inboxType].error = action.payload;
			state[inboxType].isLoading = false;
		},
		[threadActions.search.pending]: (state, action) => {
			state[action.meta.arg.inboxType.toLowerCase()].isLoading = true;
		},
		[threadActions.search.fulfilled]: (state, action) => {
			const inboxType = action.meta.arg.inboxType.toLowerCase();
			state[inboxType].isLoading = false;
			state[inboxType].threads = action.payload.threads || [];
			state[inboxType].page = action.payload.paging.page;
		},
		[threadActions.search.rejected]: (state, action) => {
			state[action.meta.arg.inboxType.toLowerCase()].isLoading = true;
		},
		[threadActions.fetchConversation.pending]: (state) => {
			state.threadMessages.isLoading = true;
		},
		[threadActions.fetchConversation.fulfilled]: (state, action) => {
			const { messages, thread } = action.payload;
			state.threadMessages.isLoading = false;
			state.threadMessages.messages = formatMessages(messages);
			state.threadMessages.wasActiveInLast24Hrs = didCandidateWhatsAppInLast24hrs(messages);
			state.threadMessages.relatedThread = action.payload.relatedThread || {};
			state.threadMessages.ariState.sequenceEnabled = Boolean(thread && thread.sequenceEnabled);
			state.threadMessages.ariState.thread.sequenceEnabled = Boolean(
				thread && thread.sequenceEnabled
			);
		},
		[threadActions.fetchConversation.rejected]: (state, action) => {
			state.threadMessages.isLoading = false;
			state.threadMessages.error = action.payload.error;
		},
		[threadActions.realtimeMsg]: (state, action) => setMessages(state, action),
		[threadActions.sendSingle.fulfilled]: (state, action) => setMessages(state, action),
		[threadActions.updateUnreadMsgs]: (state, action) => {
			const targetThread = { ...action.payload };
			const indexes = getTargetThreadIndexes(state, targetThread.id);
			targetThread.unreadMessageCount = 0;
			targetThread.read = true;

			const updatedCount = (currentCount, unreadMessageCount) => {
				const x = currentCount - unreadMessageCount;
				return x < 0 ? 0 : x;
			};

			// Found in both inboxes (threads)
			if (indexes.user !== -1) {
				const userL = state.user.threads.slice(0, indexes.user);
				const userR = state.user.threads.slice(indexes.user + 1);
				const teamL = state.team.threads.slice(0, indexes.team);
				const teamR = state.team.threads.slice(indexes.user + 1);
				state.user.threads = userL.concat(targetThread).concat(userR);
				state.user.totalUnreadMessageCount = updatedCount(
					state.user.totalUnreadMessageCount,
					action.payload.unreadMessageCount
				);
				state.team.threads = teamL.concat(targetThread).concat(teamR);
				state.team.totalUnreadMessageCount = updatedCount(
					state.team.totalUnreadMessageCount,
					action.payload.unreadMessageCount
				);
			}
			// Team only
			if (indexes.team !== -1) {
				const teamL = state.team.threads.slice(0, indexes.team);
				const teamR = state.team.threads.slice(indexes.user + 1);
				state.team.threads = teamL.concat(targetThread).concat(teamR);
				state.team.totalUnreadMessageCount = updatedCount(
					state.team.totalUnreadMessageCount,
					action.payload.unreadMessageCount
				);
			}
		},
		[threadActions.fetchThreadsWithUnreadMessages.fulfilled]: (state, action) => {
			const unreadThreadsObj = {};
			const inboxType = action.meta.arg.inboxType.toLowerCase();
			const { threads } = action.payload;
			threads.forEach((t) => (unreadThreadsObj[t.id] = t));
			const threadsUnreadCount = threads
				.map((t) => t.unreadMessageCount)
				.reduce((a, b) => a + b, 0);
			state[inboxType].totalUnreadMessageCount = threadsUnreadCount;
			state[inboxType].unreadThreads = unreadThreadsObj;
		},
		[ariActions.getSequences.pending]: (state) => {
			state.threadMessages.ariState.isLoading = true;
		},
		[ariActions.getSequences.fulfilled]: (state, action) => {
			state.threadMessages.ariState.isLoading = false;
			state.threadMessages.ariState.sequences = action.payload.sequences;
		},
		[ariActions.getSequences.rejected]: (state, _action) => {
			state.threadMessages.ariState.isLoading = false;
			state.threadMessages.ariState.error = 'Error';
		},
		[ariActions.enable.pending]: (state) => {
			state.threadMessages.ariState.isEnabling = true;
		},
		[ariActions.enable.fulfilled]: (state, action) => {
			state.threadMessages.ariState.isEnabling = false;
			state.threadMessages.ariState.thread = action.payload.thread;
		},
		[ariActions.enable.rejected]: (state, _action) => {
			state.threadMessages.ariState.isEnabling = false;
			state.threadMessages.ariState.error = 'Error';
		},
		[ariActions.disable.pending]: (state) => {
			state.threadMessages.ariState.isDisabling = true;
		},
		[ariActions.disable.fulfilled]: (state, action) => {
			state.threadMessages.ariState.isDisabling = false;
			state.threadMessages.ariState.thread = action.payload.thread;
		},
		[ariActions.disable.rejected]: (state, _action) => {
			state.threadMessages.ariState.isDisabling = false;
			state.threadMessages.ariState.error = 'Error';
		}
	}
});

export default threadSlice;
